import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  loading: {
    alignItems: 'center',
    backgroundColor: theme.colors.form__background_primary,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    height: 400,
    justifyContent: 'center',
    maxWidth: 'unset',
    padding: theme.spacing(12),
    width: 1280
  },
  spinner: {
    width: 96,
    height: 96
  },
  spinnerText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.colorPalette.green_100
  },
  coveragesInfo: {
    width: 580,
    padding: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  icon: {
    marginBottom: theme.spacing(2),
    width: 40
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  contentLabel: {
    color: theme.colorPalette.green_15
  },
  changes: {
    margin: 0,
    paddingLeft: theme.spacing(6)
  },
  notification: {
    margin: 0,
    padding: theme.spacing(4)
  },
  button: {
    alignSelf: 'center',
    fontSize: 16,
    fontWeight: 600,
    marginTop: theme.spacing(4),
    padding: theme.spacing(0, 4),
    width: 'fit-content'
  }
});

export default makeStyles(styles);
